/**
 * Hand the user a file made in the browser (CSV, JSON, text). The object
 * URL is revoked a little later, not right after the click: some browsers
 * (Safari, older Firefox) start the download asynchronously and would get
 * a dead URL.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  const url = a.href;
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 30_000);
}
